module.exports = "<div id=\"sourceCanvasWrapper\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src634836211/src/src/app/dashboard/charts/source-chart/source-chart.component.html
// module id = ../../../../../src/app/dashboard/charts/source-chart/source-chart.component.html
// module chunks = main